export const FETCH_SERVICES_REQUEST = 'FETCH_SERVICES_REQUEST';
export const FETCH_SERVICES_SUCCESS = 'FETCH_SERVICES_SUCCESS';
export const FETCH_SERVICES_FAILURE = 'FETCH_SERVICES_FAILURE';

export const GET_SERVICE_BY_ID_REQUEST = 'GET_SERVICE_BY_ID_REQUEST';
export const GET_SERVICE_BY_ID_SUCCESS = 'GET_SERVICE_BY_ID_SUCCESS';
export const GET_SERVICE_BY_ID_FAILURE = 'GET_SERVICE_BY_ID_FAILURE';

export const DELETE_SERVICE_BY_ID_REQUEST = 'DELETE_SERVICE_BY_ID_REQUEST';
export const DELETE_SERVICE_BY_ID_SUCCESS = 'DELETE_SERVICE_BY_ID_SUCCESS';
export const DELETE_SERVICE_BY_ID_FAILURE = 'DELETE_SERVICE_BY_ID_FAILURE';

export const FETCH_SERVICES_DATA_REQUEST = 'FETCH_SERVICES_DATA_REQUEST';
export const FETCH_SERVICES_DATA_SUCCESS = 'FETCH_SERVICES_DATA_SUCCESS';
export const FETCH_SERVICES_DATA_FAILURE = 'FETCH_SERVICES_DATA_FAILURE';

export const ADD_SERVICES_DATA_REQUEST = 'ADD_SERVICES_DATA_REQUEST';
export const ADD_SERVICES_DATA_SUCCESS = 'ADD_SERVICES_DATA_SUCCESS';
export const ADD_SERVICES_DATA_FAILURE = 'ADD_SERVICES_DATA_FAILURE';

export const UPDATE_SERVICES_DATA_REQUEST = 'UPDATE_SERVICES_DATA_REQUEST';
export const UPDATE_SERVICES_DATA_SUCCESS = 'UPDATE_SERVICES_DATA_SUCCESS';
export const UPDATE_SERVICES_DATA_FAILURE = 'UPDATE_SERVICES_DATA_FAILURE';

export const DELETE_SERVICES_DATA_REQUEST = 'DELETE_SERVICES_DATA_REQUEST';
export const DELETE_SERVICES_DATA_SUCCESS = 'DELETE_SERVICES_DATA_SUCCESS';
export const DELETE_SERVICES_DATA_FAILURE = 'DELETE_SERVICES_DATA_FAILURE';


export const RESET_SERVICES = 'RESET_SERVICES';

export const CREATE_SERVICES_REQUEST = 'CREATE_SERVICES_REQUEST';
export const CREATE_SERVICES_SUCCESS = 'CREATE_SERVICES_SUCCESS';
export const CREATE_SERVICES_FAILURE = 'CREATE_SERVICES_FAILURE';

export const UPDATE_SERVICES_REQUEST = 'UPDATE_SERVICES_REQUEST';
export const UPDATE_SERVICES_SUCCESS = 'UPDATE_SERVICES_SUCCESS';
export const UPDATE_SERVICES_FAILURE = 'UPDATE_SERVICES_FAILURE';

